export const LEGAL_DOC_URLS = {
  officialSite: '/legal/official-site.pdf',
  pdnConsent: '/legal/pdn-consent.pdf',
} as const;

export const COOKIE_CONSENT_STORAGE_KEY = 'qwartet_cookie_consent';

export function readCookieConsent(): boolean {
  try {
    return localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function persistCookieConsent(): void {
  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, '1');
  } catch {
    // ignore quota / private mode
  }
}

export const CONSENTS_PATH = '/app/consents';

export function needsLegalConsentsFromUser(user: unknown): boolean {
  if (!user || typeof user !== 'object') return false;
  const o = user as Record<string, unknown>;
  return o.pdnAccepted !== true || o.cookiesAccepted !== true;
}

export function postAuthLandingPath(user: unknown, fallback = '/app'): string {
  if (needsLegalConsentsFromUser(user)) return CONSENTS_PATH;
  return fallback || '/app';
}

export function needsLegalConsentsFromProfile(profile: {
  pdnAccepted?: boolean;
  cookiesAccepted?: boolean;
}): boolean {
  return profile.pdnAccepted !== true || profile.cookiesAccepted !== true;
}
